import { useCallback, useState } from 'react';

export function useAsyncHandler<Args extends Array<any> = any[], Return = any>(
  props: IUseAsyncHandlerProps<Args, Return>,
) {
  const [isLoading, setIsLoading] = useState(false);

  const handlerWrapper = useCallback(
    async (...args: Args) => {
      setIsLoading(true);
      await props.handler?.(...args);
      setIsLoading(false);
    },
    [props.handler, ...(props.dependencies ?? [])],
  );

  return {
    isLoading,
    handler: handlerWrapper,
  };
}

export interface IUseAsyncHandlerProps<Args extends Array<any> = any[], Return = any> {
  handler?: (...args: Args) => Return;
  dependencies?: any[];
}
